// @flow
import { Component } from 'react';

export type Props = {
  value: string,
  onClick: () => void
}

export class Setting extends Component<Props> {}
